"use strict";
/**
 * Transliteration mappings.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndingMapping = exports.NextMapping = exports.PrevMapping = exports.LetterMapping = exports.Mapping = exports.BASE_MAPPING = void 0;
exports.BASE_MAPPING = new Map([
    ["а", "a"],
    ["б", "b"],
    ["в", "v"],
    ["г", "g"],
    ["д", "d"],
    ["е", "e"],
    ["з", "z"],
    ["и", "i"],
    ["к", "k"],
    ["л", "l"],
    ["м", "m"],
    ["н", "n"],
    ["о", "o"],
    ["п", "p"],
    ["р", "r"],
    ["с", "s"],
    ["т", "t"],
    ["у", "u"],
    ["ф", "f"],
]);
/** Letter map for transliteration schema. */
var Mapping = /** @class */ (function () {
    function Mapping(mapping) {
        this.map = new Map(mapping);
    }
    Mapping.prototype.valueOf = function () {
        return this.map;
    };
    /**
     * Return mapped value for `key` if key is in the map, else `defaultValue`.
     */
    Mapping.prototype.get = function (key, defaultValue) {
        var value = this.map.get(key);
        return value !== undefined ? value : defaultValue;
    };
    return Mapping;
}());
exports.Mapping = Mapping;
/** Mapping for individual letters. */
var LetterMapping = /** @class */ (function (_super) {
    __extends(LetterMapping, _super);
    function LetterMapping(mapping) {
        var e_1, _a;
        var _this = _super.call(this, mapping) || this;
        var upperMap = new Map();
        try {
            for (var mapping_1 = __values(mapping), mapping_1_1 = mapping_1.next(); !mapping_1_1.done; mapping_1_1 = mapping_1.next()) {
                var _b = __read(mapping_1_1.value, 2), key = _b[0], value = _b[1];
                upperMap.set(capitalize(key), capitalize(value));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (mapping_1_1 && !mapping_1_1.done && (_a = mapping_1.return)) _a.call(mapping_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        _this.map = new Map(__spread(_this.map, upperMap));
        return _this;
    }
    return LetterMapping;
}(Mapping));
exports.LetterMapping = LetterMapping;
/** Mapping for letters with respect to previous sibling. */
var PrevMapping = /** @class */ (function (_super) {
    __extends(PrevMapping, _super);
    function PrevMapping(mapping) {
        var e_2, _a, e_3, _b;
        var _this = _super.call(this, mapping) || this;
        var upperMap1 = new Map();
        try {
            for (var mapping_2 = __values(mapping), mapping_2_1 = mapping_2.next(); !mapping_2_1.done; mapping_2_1 = mapping_2.next()) {
                var _c = __read(mapping_2_1.value, 2), key = _c[0], value = _c[1];
                upperMap1.set(capitalize(key), value);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (mapping_2_1 && !mapping_2_1.done && (_a = mapping_2.return)) _a.call(mapping_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        var upperMap2 = new Map();
        try {
            for (var mapping_3 = __values(mapping), mapping_3_1 = mapping_3.next(); !mapping_3_1.done; mapping_3_1 = mapping_3.next()) {
                var _d = __read(mapping_3_1.value, 2), key = _d[0], value = _d[1];
                upperMap2.set(key.toUpperCase(), capitalize(value));
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (mapping_3_1 && !mapping_3_1.done && (_b = mapping_3.return)) _b.call(mapping_3);
            }
            finally { if (e_3) throw e_3.error; }
        }
        _this.map = new Map(__spread(_this.map, upperMap1, upperMap2));
        return _this;
    }
    return PrevMapping;
}(Mapping));
exports.PrevMapping = PrevMapping;
/** Mapping for letters with respect to next sibling. */
var NextMapping = /** @class */ (function (_super) {
    __extends(NextMapping, _super);
    function NextMapping(mapping) {
        var e_4, _a, e_5, _b;
        var _this = _super.call(this, mapping) || this;
        var upperMap1 = new Map();
        try {
            for (var mapping_4 = __values(mapping), mapping_4_1 = mapping_4.next(); !mapping_4_1.done; mapping_4_1 = mapping_4.next()) {
                var _c = __read(mapping_4_1.value, 2), key = _c[0], value = _c[1];
                upperMap1.set(capitalize(key), capitalize(value));
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (mapping_4_1 && !mapping_4_1.done && (_a = mapping_4.return)) _a.call(mapping_4);
            }
            finally { if (e_4) throw e_4.error; }
        }
        var upperMap2 = new Map();
        try {
            for (var mapping_5 = __values(mapping), mapping_5_1 = mapping_5.next(); !mapping_5_1.done; mapping_5_1 = mapping_5.next()) {
                var _d = __read(mapping_5_1.value, 2), key = _d[0], value = _d[1];
                upperMap2.set(key.toUpperCase(), capitalize(value));
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (mapping_5_1 && !mapping_5_1.done && (_b = mapping_5.return)) _b.call(mapping_5);
            }
            finally { if (e_5) throw e_5.error; }
        }
        _this.map = new Map(__spread(_this.map, upperMap1, upperMap2));
        return _this;
    }
    return NextMapping;
}(Mapping));
exports.NextMapping = NextMapping;
/** Mapping for word endings. */
var EndingMapping = /** @class */ (function (_super) {
    __extends(EndingMapping, _super);
    function EndingMapping(mapping) {
        var e_6, _a;
        var _this = _super.call(this, mapping) || this;
        var upperMap = new Map();
        try {
            for (var mapping_6 = __values(mapping), mapping_6_1 = mapping_6.next(); !mapping_6_1.done; mapping_6_1 = mapping_6.next()) {
                var _b = __read(mapping_6_1.value, 2), key = _b[0], value = _b[1];
                upperMap.set(key.toUpperCase(), value.toUpperCase());
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (mapping_6_1 && !mapping_6_1.done && (_a = mapping_6.return)) _a.call(mapping_6);
            }
            finally { if (e_6) throw e_6.error; }
        }
        _this.map = new Map(__spread(_this.map, upperMap));
        return _this;
    }
    return EndingMapping;
}(Mapping));
exports.EndingMapping = EndingMapping;
/** Capitalize string */
function capitalize(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}
